<template>
  <div class="hello">
    <GlobalHeader style="position: absolute;" :activeIndex="activeIndex" />
    <el-main>
      <div class="gray-background" v-loading="loading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div style="width: 95%; height: calc(100vh - 50px); overflow-y: scroll;">
          <div>
            <div class="conte_left">
              <div style="width: 460px;padding: 0  10px;">
                <div style="width: 460px;">
                  <div class="btn_box">
                    <el-select v-model="year" @change="year_type" placeholder="请选择" style="width: 150px;height: 30px;">
                      <el-option v-for="option in options1" :key="option.value" :label="option.label"
                        :value="{ value: option.value, label: option.label }"></el-option>
                    </el-select>
                  </div>
                  <div class="btn">
                    <div class="fund">
                      <div style="margin-top: 10px;">
                        <span style="color: #b4b3b3;">现有总资金:</span>
                        <span style="font-weight: 700;font-size: 27px;margin-top: -35px;">{{ tableData_one.amount_total ||
                          '' }}</span>
                      </div>
                      <div class="fund_box" style="margin-top: 40px;">
                        <div>
                          <span style="color: #b4b3b3;">报销未支付:</span>
                          <span>{{ tableData_one.unreimbursement }}</span>
                        </div>
                        <div style="margin-top: 10px;">
                          <span style="color: #b4b3b3;">公司人数 :&nbsp;&nbsp;</span>
                          <span>{{ tableData_one.staff_total }} </span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="fund">
                        <div style="margin-top: 10px;">
                          <span style="color: #b4b3b3;">总未回款 :</span>
                          <br>
                          <span style="font-weight: 700;font-size: 27px;margin-top: -35px;">{{
                            tableData_one.project_unback || '' }} </span>
                        </div>
                        <div class="fund_box" style="margin-top: 40px;">
                          <div>
                            <span style="color: #b4b3b3;">回款为指认 :</span>
                            <span>{{ tableData_one.income_unidentify }} </span>
                          </div>
                          <div style="margin-top: 10px;">
                            <span style="color: #b4b3b3;">实际未回款 :</span>
                            <span>{{ tableData_one.actual_unbacked }} </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table_one">
                    <table class="table_box">
                      <thead>
                        <tr>
                          <th></th>
                          <th>当年合计</th>
                          <th>同比上年</th>
                          <th>历年合计</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style="color:#b4b3b3">签单金额</td>
                          <td>{{ tableData_one.year_amount }}</td>
                          <td>{{ tableData_one.compared_amount}}%</td>
                          <td>{{ tableData_one.all_amount }}</td>
                        </tr>
                        <tr>
                          <td style="color:#b4b3b3">回款金额</td>
                          <td>{{ tableData_one.year_income }}</td>
                          <td>{{ tableData_one.compare_income}}%</td>
                          <td>{{ tableData_one.all_income }}</td>
                        </tr>
                        <tr>
                          <td style="color:#b4b3b3">支出金额</td>
                          <td>{{ tableData_one.year_expend }}</td>
                          <td>{{ tableData_one.compare_expend}}%</td>
                          <td>{{ tableData_one.all_expend }}</td>
                        </tr>
                        <tr>
                          <td style="color:#b4b3b3">签单数量</td>
                          <td>{{ tableData_one.year_count }}</td>
                          <td>{{ tableData_one.compare_count}}%</td>
                          <td>{{ tableData_one.all_count }}</td>
                        </tr>
                        <tr>
                          <td style="color:#b4b3b3">新客户数量</td>
                          <td>{{ tableData_one.year_customer }}</td>
                          <td>{{ tableData_one.compare_customer}}%</td>
                          <td>{{ tableData_one.all_customer }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div>
                <div class="line-chart" ref="chart"
                  style="width:1250px;height: 430px !important;  margin:50px 0px 0px  20px;background-color: #fff;border-radius: 5px;">
                </div>
              </div>
            </div>
          </div>
          <div style="height: 800px;">
            <div>
              <el-table :data="project_box" style="width:1720px;
                        border-radius: 5px;margin-top: 15px;font-size: 12px;margin-left:10px;">
                <el-table-column label="" prop="name" width="150">
                  <template slot-scope="props">
                    <span style="color:#b4b3b3">{{ props.row.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="合计" prop="total" width="150">
                  <template slot-scope="props">
                    <span style="font-weight: 600;" :style="{ color: props.row.total == 0 ? '#fff' : '#000' }">{{
                      props.row.total }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="1月" prop="1" width="100">
                  <template slot-scope="props">
                    <span :style="{ color: props.row['1'] == 0 ? '#fff' : (props.row['1'] > 0 ? '#000' : 'red') }"> {{
                      props.row['1'] }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="2月" prop="2" width="100">
                  <template slot-scope="props">
                    <span :style="{ color: props.row['2'] == 0 ? '#fff' : (props.row['2'] > 0 ? '#000' : 'red') }"> {{
                      props.row['2'] }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="3月" prop="3" width="100">
                  <template slot-scope="props">
                    <span :style="{ color: props.row['3'] == 0 ? '#fff' : (props.row['3'] > 0 ? '#000' : 'red') }"> {{
                      props.row['3'] }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="4月" prop="4" width="100">
                  <template slot-scope="props">
                    <span :style="{ color: props.row['4'] == 0 ? '#fff' : (props.row['4'] > 0 ? '#000' : 'red') }"> {{
                      props.row['4'] }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="5月" prop="5" width="100">
                  <template slot-scope="props">
                    <span :style="{ color: props.row['5'] == 0 ? '#fff' : (props.row['5'] > 0 ? '#000' : 'red') }"> {{
                      props.row['5'] }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="6月" prop="6" width="100">
                  <template slot-scope="props">
                    <span :style="{ color: props.row['6'] == 0 ? '#fff' : (props.row['6'] > 0 ? '#000' : 'red') }"> {{
                      props.row['6'] }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="7月" prop="7" width="100">
                  <template slot-scope="props">
                    <span :style="{ color: props.row['7'] == 0 ? '#fff' : (props.row['7'] > 0 ? '#000' : 'red') }"> {{
                      props.row['7'] }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="8月" prop="8" width="100">
                  <template slot-scope="props">
                    <span :style="{ color: props.row['8'] == 0 ? '#fff' : (props.row['8'] > 0 ? '#000' : 'red') }"> {{
                      props.row['8'] }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="9月" prop="9" width="100">
                  <template slot-scope="props">
                    <span :style="{ color: props.row['9'] == 0 ? '#fff' : (props.row['9'] > 0 ? '#000' : 'red') }"> {{
                      props.row['9'] }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="10月" prop="10" width="100">
                  <template slot-scope="props">
                    <span :style="{ color: props.row['10'] == 0 ? '#fff' : (props.row['10'] > 0 ? '#000' : 'red') }"> {{
                      props.row['10'] }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="11月" prop="11" width="100">
                  <template slot-scope="props">
                    <span :style="{ color: props.row['11'] == 0 ? '#fff' : (props.row['11'] > 0 ? '#000' : 'red') }"> {{
                      props.row['11'] }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="12月" prop="12">
                  <template slot-scope="props">
                    <span :style="{ color: props.row['12'] == 0 ? '#fff' : (props.row['12'] > 0 ? '#000' : 'red') }"> {{
                      props.row['12'] }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style=" margin:20px 0; width:1720px;background: #fff;border-radius: 5px; margin-left: 10px;">
              <div class="max">
                <div class="container">
                  <span class="tab" @click="selectTab(1)" :class="{ active: currentTab == 1 }">占签单比</span>
                  <span class="tab" @click="selectTab(2)" :class="{ active: currentTab == 2 }">占完工比</span>
                  <span class="tab" @click="selectTab(3)" :class="{ active: currentTab == 3 }">占回款比</span>
                  <div style="display: flex; align-items: center; margin-left: 30px;">
                    <div>
                      <span style="color: #b4b3b3;border:none;padding: 5px 0;">当年签单:</span>
                      <span style="border:none;padding: 5px 0px;font-weight: 600;">{{ one  }}</span>
                    </div>
                    <div style="margin-left: 20px;">
                      <span style="color: #b4b3b3;border:none;padding: 5px 0;margin-left: 20px;">当年完工:</span>
                      <span style="border:none;padding: 5px 0px;font-weight: 600;">{{ two }}</span>
                    </div>
                    <div style="margin-left: 20px;">
                      <span style="color: #b4b3b3;border:none;padding: 5px 0;margin-left: 20px;">当年回款:</span>
                      <span style="border:none;padding: 5px 0px;font-weight: 600;">{{ three}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tabs" style="margin-top: -20px;">
                <div class="tab-content" v-if="currentTab == 1">
                  <div>
                    <div style="display: flex;height: 500px;align-items: center;justify-content: space-evenly;">
                      <div style="display: flex;">
                        <div ref="pieChart_two" style="width:570px; height: 400px;">
                        </div>
                        <div ref="pieChart_two_1" style="width:570px; height: 400px;">
                        </div>
                        <div ref="pieChart_two_2" style="width:570px; height: 400px;">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <el-table :data="type" style="width: 99%;margin-left: 10px;cursor: pointer;">
                      <el-table-column prop="name" label="产品类型" width="120">
                        <template slot-scope="props">
                          <span style="color:#b4b3b3" v-if="!props.row.name.includes('利润')">{{ props.row.name }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="total" label="合计" width="80">
                        <template slot-scope="props">
                          <span style="font-weight: 600;">{{ props.row.total }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="1" label="1月" width="80">
                      </el-table-column>
                      <el-table-column prop="2" label="2月" width="80">
                      </el-table-column>
                      <el-table-column prop="3" label="3月" width="80">
                      </el-table-column>
                      <el-table-column prop="4" label="4月" width="80">
                      </el-table-column>
                      <el-table-column prop="5" label="5月" width="80">
                      </el-table-column>
                      <el-table-column prop="6" label="6月" width="80">
                      </el-table-column>
                      <el-table-column prop="7" label="7月" width="80">
                      </el-table-column>
                      <el-table-column prop="8" label="8月" width="80">
                      </el-table-column>
                      <el-table-column prop="9" label="9月" width="80">
                      </el-table-column>
                      <el-table-column prop="10" label="10月" width="80">
                      </el-table-column>
                      <el-table-column prop="11" label="11月" width="80">
                      </el-table-column>
                      <el-table-column prop="12" label="12月">
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
                <div class="tab-content" v-if="currentTab == 2">
                  <div>
                    <div style="display: flex;height: 500px;align-items: center;justify-content: space-evenly;">
                      <div style="display: flex;">
                        <div ref="pieChart_one" style="width:570px; height: 400px;">
                        </div>
                        <div ref="pieChart_one_1" style="width:570px; height: 400px;">
                        </div>
                        <div ref="pieChart_one_2" style="width:570px; height: 400px;">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <el-table :data="type_ch" style="width: 99%;margin-left: 10px;cursor: pointer;">
                      <el-table-column prop="name" label="产品类型" width="120">
                        <template slot-scope="props">
                          <span style="color:#b4b3b3"  v-if="!props.row.name.includes('利润')">{{ props.row.name }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="total" label="合计" width="80">
                        <template slot-scope="props">
                          <span style="font-weight: 600;">{{ props.row.total }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="1" label="1月" width="80">
                      </el-table-column>
                      <el-table-column prop="2" label="2月" width="80">
                      </el-table-column>
                      <el-table-column prop="3" label="3月" width="80">
                      </el-table-column>
                      <el-table-column prop="4" label="4月" width="80">
                      </el-table-column>
                      <el-table-column prop="5" label="5月" width="80">
                      </el-table-column>
                      <el-table-column prop="6" label="6月" width="80">
                      </el-table-column>
                      <el-table-column prop="7" label="7月" width="80">
                      </el-table-column>
                      <el-table-column prop="8" label="8月" width="80">
                      </el-table-column>
                      <el-table-column prop="9" label="9月" width="80">
                      </el-table-column>
                      <el-table-column prop="10" label="10月" width="80">
                      </el-table-column>
                      <el-table-column prop="11" label="11月" width="80">
                      </el-table-column>
                      <el-table-column prop="12" label="12月">
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
                <div class="tab-content" v-if="currentTab == 3">
                  <div>
                    <div style="display: flex;height: 500px;align-items: center;justify-content: space-evenly;">
                      <div style="display: flex;">
                        <div ref="pieChart_three" style="width:570px; height: 400px;">
                        </div>
                        <div ref="pieChart_three_1" style="width:570px; height: 400px;">
                        </div>
                        <div ref="pieChart_three_2" style="width:570px; height: 400px;">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <el-table :data="department" style="width: 99%;margin-left: 10px;cursor: pointer;">
                      <el-table-column prop="name" label="产品类型" width="120">
                        <template slot-scope="props">
                          <span style="color:#b4b3b3"  v-if="!props.row.name.includes('利润')">{{ props.row.name }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="total" label="合计" width="80">
                        <template slot-scope="props">
                          <span style="font-weight: 600;">{{ props.row.total }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="1" label="1月" width="80">
                      </el-table-column>
                      <el-table-column prop="2" label="2月" width="80">
                      </el-table-column>
                      <el-table-column prop="3" label="3月" width="80">
                      </el-table-column>
                      <el-table-column prop="4" label="4月" width="80">
                      </el-table-column>
                      <el-table-column prop="5" label="5月" width="80">
                      </el-table-column>
                      <el-table-column prop="6" label="6月" width="80">
                      </el-table-column>
                      <el-table-column prop="7" label="7月" width="80">
                      </el-table-column>
                      <el-table-column prop="8" label="8月" width="80">
                      </el-table-column>
                      <el-table-column prop="9" label="9月" width="80">
                      </el-table-column>
                      <el-table-column prop="10" label="10月" width="80">
                      </el-table-column>
                      <el-table-column prop="11" label="11月" width="80">
                      </el-table-column>
                      <el-table-column prop="12" label="12月">
                      </el-table-column>
                    </el-table>
                  </div>
                </div>


              </div>
            </div>
            <div style="height:1px;"></div>
          </div>
        </div>
      </div>
    </el-main>
  </div>
</template>
<script>
import * as echarts from 'echarts';
import GlobalHeader from '@/components/GlobalHeader.vue'
import { OperationApi } from "@/api/echarts/index.js"


export default {
  components: {
    GlobalHeader,
  },
  data() {
    return {
      activeIndex: "10",
      currentTab: 1,
      tableData_one: [],
      tableData: [],
      year: {
        value: '10',
        label: '2026'
      },
      options1: [
        { value: '10', label: '2026' }, // 将2025放在最前面
        { value: '9', label: '2025' }, // 将2025放在最前面
        { value: '8', label: '2024' },
        { value: '7', label: '2023' },
        { value: '6', label: '2022' },
        { value: '5', label: '2021' },
        { value: '4', label: '2020' },
        { value: '3', label: '2019' },
        { value: '2', label: '2018' },
        { value: '1', label: '2017' }
      ],

      echarts_one: [],
      amountData: [],
      project_box: [{}],
      department: [],
      type: [],
      type_ch: [],
      loading: false,
      a: null,

      one: null,
      two: null,
      three: null,
    };
  },
  created() {
    this.loading = true
    OperationApi({
      year: this.year.label,
    }).then(res => {
      this.tableData_one = res.data;
      this.project_box = res.data.project;
      this.department = res.data.expend.department;

      this.type = res.data.expend.type;
      this.type_ch = res.data.expend.type_ch;
      let arr = res.data.chart;

        this.type.forEach((item) => {
           if (item.backed_profit || item.converted_profit || item.finish_profit) {
          return;
        }
        this.one = item.converted_amount;
        this.two = item.finish_amount;
        this.three = item.backed_amount;
        });
      this.echarts_one = arr.slice(1, 15)
      this.echarts_one = this.echarts_one.map(val => {
        return {
          name: val[0],
          type: 'line',
          data: val.slice(1, 13)
        }
      })

      this.loading = false;
      this.initChart();
      this.initChart_tow()
      this.initChart_tow_1()
      this.initChart_tow_2()

    })
  },
  computed: {
  },
  mounted() {
    this.initChart();
  },
  methods: {
    //排序
    selectTab(tab) {
      this.currentTab = tab;
      this.getList();
    },
    //客户类型
    year_type(selectedValues) {
      this.year = selectedValues.label;
      this.getList();
    },
    initChart() {
      const chartDom = this.$refs.chart;
      const myChart = echarts.init(chartDom);
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          source: this.echarts_one
        },
        xAxis: {
          type: 'category',
          data: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
        },
        yAxis: {
          type: 'value',
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: this.echarts_one
      };
      myChart.setOption(option);
    },

    initChart_tow() {
      const pieChart = echarts.init(this.$refs.pieChart_two);

      let self = this; // 保存对this的引用
      if (this.type.length === 0) {
        return; // 如果数据为空，不渲染图表
      }
      pieChart.setOption({
        title: {
          text: '支出大类', // 标题内容为"占签单比"
          left: 10, // 距离左侧的距离
          top: 10, // 距离顶部的距离
          textStyle: {
            color: '#333', // 标题颜色
            fontSize: 16, // 标题字体大小
          }
        },
        xAxis: {
          type: 'category',
          data: this.type.map((item) => {
            if (item.name !== "总计") {
              return item.name;
            }
          }), // 将total值添加到data数组中
          axisLabel: {
            rotate: 50, // 将文字旋转90度
          }
        },
        yAxis: {
          type: 'value',
          max: 100,
          inverse: false // 设置坐标轴反转，使负值朝上
        },
        series: [{
          type: 'bar',
          barWidth: '30%', // 设置柱状图的宽度
          barGap: '-60%', // 调整柱状图的位置偏移量
          data: this.type.map((item) => {
            if (item.name !== "总计") {
              return {
                value: item.converted_profit_rate,
                itemStyle: {
                  color: item.converted_profit_rate >= 0 ? '#0a652f' : 'red' // 利润正数蓝色，负数红色
                },
              };
            }
          })
        },
        {
            type: 'bar',
            data: this.type.map((item) => {
              if (item.name !== "总计") {
                return item.converted_amount_rate;
              }
            }),
            itemStyle: {
              normal: {
                color: function (params) {
                  return params.value >= 0 ? 'blue' : '#0a652f'; // 利润率正数绿色，负数橙色
                },
              }
            }
          }],
        tooltip: {
          formatter: function (params) {
            let item = self.type.find((element) => element.name === params.name);
            if (item) {
              return params.name + ': ' + (params.value) + '%' + ':' + (item.total ? item.total : '') + ' : ' + (item.converted_profit ? item.converted_profit : '');
            }
          }
        }
      });
    },
    initChart_tow_1() {
      const pieChart = echarts.init(this.$refs.pieChart_two_1)

      let self = this; // 保存对this的引用
      if (this.type_ch.length === 0) {
        return; // 如果数据为空，不渲染图表
      }
      pieChart.setOption({
        title: {
          text: '支出小类', // 标题内容为"占签单比"
          left: 10, // 距离左侧的距离
          top: 10, // 距离顶部的距离
          textStyle: {
            color: '#333', // 标题颜色
            fontSize: 16, // 标题字体大小
          }
        },
        xAxis: {
          type: 'category',
          data: this.type_ch.map((item) => {
            if (item.name !== "总计") {
              return item.name;
            }
          }), // 将total值添加到data数组中
          axisLabel: {
            rotate: 50  // 将文字旋转90度
          }
        },
        yAxis: {
          type: 'value',
          max: 100,
          inverse: false  // 设置坐标轴反转，使负值朝上
        },
        series: [{
          type: 'bar',
          barWidth: '30%', // 设置柱状图的宽度
          barGap: '-60%', // 调整柱状图的位置偏移量
          data: this.type_ch.map((item) => {
            if (item.name !== "总计") {
              return item.converted_profit_rate; // 利润数据
            }
          }),
          itemStyle: {
            normal: {
              color: function (params) {
                return params.value >= 0 ? '#0a652f' : 'red'; // 利润正数蓝色，负数红色
              },
            }
          }
        },
        {
          type: 'bar',
          data: this.type_ch.map((item) => {
            if (item.name !== "总计") {
              return item.converted_amount_rate;
            }
          }),
          itemStyle: {
            normal: {
              color: function (params) {
                return params.value >= 0 ? 'blue' : '#0a652f'; // 利润率正数绿色，负数橙色
              },
            }
          }
        }],
        tooltip: {
          formatter: function (params) {
            let item = self.type_ch.find((element) => element.name === params.name);
            if (item) {
              if (item) {
                return params.name + ': ' + (params.value) + '%' + ':' + (item.total ? item.total : '') + ' : ' + (item.converted_profit ? item.converted_profit : '');
              }
            }
          }
        }
      });
    },
    initChart_tow_2() {
      const pieChart = echarts.init(this.$refs.pieChart_two_2)

      let self = this; // 保存对this的引用
      if (this.department.length === 0) {
        return; // 如果数据为空，不渲染图表
      }
      pieChart.setOption({
         title: {
          text: '结算部门', // 标题内容为"占签单比"
          left: 10, // 距离左侧的距离
          top: 10, // 距离顶部的距离
          textStyle: {
            color: '#333', // 标题颜色
            fontSize: 16, // 标题字体大小
          }
        },
        xAxis: {
          type: 'category',
          data: this.department.map((item) => {
            if (item.name !== "总计") {
              return item.name;
            }
          }),
          axisLabel: {
            rotate: 60  // 将文字旋转90度
          }
        },
        yAxis: {
          type: 'value',
          max: 100,
          inverse: false  // 设置坐标轴反转，使负值朝上
        },
        series: [{
          type: 'bar',
          barWidth: '30%', // 设置柱状图的宽度
          barGap: '-60%', // 调整柱状图的位置偏移量
          data: this.department.map((item) => {
            if (item.name !== "总计") {
              return item.converted_profit_rate; // 利润数据
            }
          }),
          itemStyle: {
            normal: {
              color: function (params) {
                return params.value >= 0 ? '#0a652f' : 'red'; // 利润正数蓝色，负数红色
              },
            }
          }
        },
        {
          type: 'bar',
          data: this.department.map((item) => {
            if (item.name !== "总计") {
              return item.converted_amount_rate;
            }
          }),
          itemStyle: {
            normal: {
              color: function (params) {
                return params.value >= 0 ? 'blue' : '#0a652f'; // 利润率正数绿色，负数橙色
              },
            }
          }
        }],
        tooltip: {
          formatter: function (params) {
            let item = self.department.find((element) => element.name === params.name);
              if (item) {
                return params.name + ': ' + (params.value) + '%' + ':' + (item.total ? item.total : '') + ' : ' + (item.converted_profit ? item.converted_profit : '');
              }
          }
        }
      });
    },

    initChart_one() {
      const pieChart = echarts.init(this.$refs.pieChart_one)
      let self = this; // 保存对this的引用
      if (this.type.length === 0) {
        return; // 如果数据为空，不渲染图表
      }
      pieChart.setOption({
         title: {
          text: '支出大类', // 标题内容为"占签单比"
          left: 10, // 距离左侧的距离
          top: 10, // 距离顶部的距离
          textStyle: {
            color: '#333', // 标题颜色
            fontSize: 16, // 标题字体大小
          }
        },
        xAxis: {
          type: 'category',
          data: this.type.map((item) => {
            if (item.name !== "总计") {
              return item.name;
            }
          }),
          axisLabel: {
            rotate: 60  // 将文字旋转90度
          }
        },
        yAxis: {
          type: 'value',
          max: 100,
          inverse: false  // 设置坐标轴反转，使负值朝上
        },
        series: [{
          type: 'bar',
          barWidth: '30%', // 设置柱状图的宽度
          barGap: '-60%', // 调整柱状图的位置偏移量
          data: this.type.map((item) => {
            if (item.name !== "总计") {
              return item.finish_profit_rate; // 利润数据
            }
          }),
          itemStyle: {
            normal: {
              color: function (params) {
                return params.value >= 0 ? '#0a652f' : 'red'; // 利润正数蓝色，负数红色
              },
            }
          }
        },
        {
          type: 'bar',
          data: this.type.map((item) => {
            if (item.name !== "总计") {
              return item.finish_amount_rate; // 利润率数据
            }
          }),
          itemStyle: {
            normal: {
              color: function (params) {
                return params.value >= 0 ? 'blue' : '#0a652f'; // 利润率正数绿色，负数橙色
              },
            }
          }
        }],
        tooltip: {
          formatter: function (params) {
            let item = self.type.find((element) => element.name === params.name);
            if (item) {
              return params.name + ': ' + (params.value) + '%' + ':' + (item.total ? item.total : '') + ' : ' + (item.finish_profit ? item.finish_profit : '');
            }
          }
        }
      });
    },
    initChart_one_1() {
      const pieChart = echarts.init(this.$refs.pieChart_one_1)
       let self = this; // 保存对this的引用
       if (this.type_ch.length === 0) {
        return; // 如果数据为空，不渲染图表
      }
      pieChart.setOption({
        title: {
          text: '支出小类', // 标题内容为"占签单比"
          left: 10, // 距离左侧的距离
          top: 10, // 距离顶部的距离
          textStyle: {
            color: '#333', // 标题颜色
            fontSize: 16, // 标题字体大小
          }
        },
        xAxis: {
          type: 'category',
          data: this.type_ch.map((item) => {
            if (item.name !== "总计") {
              return item.name;
            }
          }),
          axisLabel: {
            rotate: 60  // 将文字旋转90度
          }
        },
        yAxis: {
          type: 'value',
          max: 100 ,
          inverse: false  // 设置坐标轴反转，使负值朝上
        },
        series: [{
          type: 'bar',
          barWidth: '30%', // 设置柱状图的宽度
          barGap: '-60%', // 调整柱状图的位置偏移量
          data: this.type_ch.map((item) => {
            if (item.name !== "总计") {
              return item.finish_profit_rate; // 利润数据
            }
          }),
          itemStyle: {
            normal: {
              color: function (params) {
                return params.value >= 0 ? '#0a652f' : 'red'; // 利润正数蓝色，负数红色
              },
            }
          }
        },
        {
          type: 'bar',
          data: this.type_ch.map((item) => {
            if (item.name !== "总计") {
              return item.finish_amount_rate;
            }
          }),
          itemStyle: {
            normal: {
              color: function (params) {
                return params.value >= 0 ? 'blue' : '#0a652f'; // 利润率正数绿色，负数橙色
              },
            }
          }
        }],
        tooltip: {
          formatter: function (params) {
            let item = self.type_ch.find((element) => element.name === params.name);
            if (item) {
                return params.name + ': ' + (params.value) + '%' + ':' + (item.total ? item.total : '') + ' : ' + (item.finish_profit ? item.finish_profit : '');
            }
          }
        }
      });
    },
    initChart_one_2() {
      const pieChart = echarts.init(this.$refs.pieChart_one_2)
       let self = this; // 保存对this的引用
       if (this.department.length === 0) {
        return; // 如果数据为空，不渲染图表
      }
      pieChart.setOption({
         title: {
          text: '结算部门', // 标题内容为"占签单比"
          left: 10, // 距离左侧的距离
          top: 10, // 距离顶部的距离
          textStyle: {
            color: '#333', // 标题颜色
            fontSize: 16, // 标题字体大小
          }
        },
        xAxis: {
          type: 'category',
          data: this.department.map((item) => {
            if (item.name !== "总计") {
              return item.name;
            }
          }),
          axisLabel: {
            rotate: 60  // 将文字旋转90度
          }
        },
        yAxis: {
          type: 'value',
          max: 100,
          inverse: false  // 设置坐标轴反转，使负值朝上
        },
        series: [{
          type: 'bar',
          barWidth: '30%', // 设置柱状图的宽度
          barGap: '-60%', // 调整柱状图的位置偏移量
          data: this.department.map((item) => {
            if (item.name !== "总计") {
              return item.finish_profit_rate; // 利润数据
            }
          }),
          itemStyle: {
            normal: {
              color: function (params) {
                return params.value >= 0 ? '#0a652f' : 'red'; // 利润正数蓝色，负数红色
              },
            }
          }
        },
        {
          type: 'bar',
          data: this.department.map((item) => {
            if (item.name !== "总计") {
              return item.finish_amount_rate;
            }
          }),
          itemStyle: {
            normal: {
              color: function (params) {
                return params.value >= 0 ? 'blue' : '#0a652f'; // 利润率正数绿色，负数橙色
              },
            }
          }
        }],
        tooltip: {
          formatter: function (params) {
            let item = self.department.find((element) => element.name === params.name);
            if (item) {
               return params.name + ': ' + (params.value) + '%' + ':' + (item.total ? item.total : '') + ' : ' + (item.finish_profit ? item.finish_profit : '');
            }
          }
        }
      });
    },

    initChart_three() {
      const pieChart = echarts.init(this.$refs.pieChart_three)
       let self = this; // 保存对this的引用
       if (this.type.length === 0) {
        return; // 如果数据为空，不渲染图表
      }
      pieChart.setOption({
         title: {
          text: '支出大类', // 标题内容为"占签单比"
          left: 10, // 距离左侧的距离
          top: 10, // 距离顶部的距离
          textStyle: {
            color: '#333', // 标题颜色
            fontSize: 16, // 标题字体大小
          }
        },
        xAxis: {
          type: 'category',
          data: this.type.map((item) => {
            if (item.name !== "总计") {
              return item.name;
            }
          }),
          axisLabel: {
            rotate: 60  // 将文字旋转90度
          }
        },
        yAxis: {
          type: 'value',
          max: 100,
          inverse: false  // 设置坐标轴反转，使负值朝上
        },
         series: [{
          type: 'bar',
           barWidth: '30%', // 设置柱状图的宽度
           barGap: '-60%', // 调整柱状图的位置偏移量
          data: this.type.map((item) => {
            if (item.name !== "总计") {
              return item.backed_profit_rate; // 利润数据
            }
          }),
          itemStyle: {
            normal: {
              color: function (params) {
                return params.value >= 0 ? '#0a652f' : 'red'; // 利润正数蓝色，负数红色
              },
            }
          }
        },
        {
          type: 'bar',
          data: this.type.map((item) => {
            if (item.name !== "总计") {
              return item.backed_amount_rate;
            }
          }),
          itemStyle: {
            normal: {
              color: function (params) {
                return params.value >= 0 ? 'blue' : '#0a652f'; // 利润率正数绿色，负数橙色
              },
            }
          }
        }],
        tooltip: {
          formatter: function (params) {
             let item = self.type.find((element) => element.name === params.name);
            if (item) {
                return params.name + ': ' + (params.value) + '%' + ':' + (item.total ? item.total : '') + ' : ' + (item.backed_profit ? item.backed_profit : '');
            }
          }
        }
      });
    },
    initChart_three_1() {
      const pieChart = echarts.init(this.$refs.pieChart_three_1)
        let self = this; // 保存对this的引用
      if (this.type_ch.length === 0) {
        return; // 如果数据为空，不渲染图表
      }
      pieChart.setOption({
         title: {
          text: '支出小类', // 标题内容为"占签单比"
          left: 10, // 距离左侧的距离
          top: 10, // 距离顶部的距离
          textStyle: {
            color: '#333', // 标题颜色
            fontSize: 16, // 标题字体大小
          }
        },
        xAxis: {
          type: 'category',
          data: this.type_ch.map((item) => {
            if (item.name !== "总计") {
              return item.name;
            }
          }),
          axisLabel: {
            rotate: 60  // 将文字旋转90度
          }
        },
        yAxis: {
          type: 'value',
          max: 100,
          inverse: false  // 设置坐标轴反转，使负值朝上
        },
        series: [{
          type: 'bar',
          barWidth: '30%', // 设置柱状图的宽度
          barGap: '-60%', // 调整柱状图的位置偏移量
          data: this.type_ch.map((item) => {
            if (item.name !== "总计") {
              return item.backed_profit_rate; // 利润数据
            }
          }),
          itemStyle: {
            normal: {
              color: function (params) {
                return params.value >= 0 ? '#0a652f' : 'red'; // 利润正数蓝色，负数红色
              },
            }
          }
        },
        {
          type: 'bar',
          data: this.type_ch.map((item) => {
            if (item.name !== "总计") {
              return item.backed_amount_rate;
            }
          }),
          itemStyle: {
            normal: {
              color: function (params) {
                return params.value >= 0 ? 'blue' : '#0a652f'; // 利润率正数绿色，负数橙色
              },
            }
          }
        }],
        tooltip: {
          formatter: function (params) {
             let item = self.type_ch.find((element) => element.name === params.name);
            if (item) {
              return params.name + ': ' + (params.value) + '%' + ':' + (item.total ? item.total : '') + ' : ' + (item.backed_profit ? item.backed_profit : '');
            }
          }
        }
      });
    },
    initChart_three_2() {
      const pieChart = echarts.init(this.$refs.pieChart_three_2)
        let self = this; // 保存对this的引用
      if (this.department.length === 0) {
        return; // 如果数据为空，不渲染图表
      }
      pieChart.setOption({
        title: {
          text: '结算部门', // 标题内容为"占签单比"
          left: 10, // 距离左侧的距离
          top: 10, // 距离顶部的距离
          textStyle: {
            color: '#333', // 标题颜色
            fontSize: 16, // 标题字体大小
          }
        },
        xAxis: {
          type: 'category',
          data: this.department.map((item) => {
            if (item.name !== "总计") {
              return item.name;
            }
          }),
          axisLabel: {
            rotate: 60  // 将文字旋转90度
          }
        },
        yAxis: {
          type: 'value',
          max: 100,
          inverse: false  // 设置坐标轴反转，使负值朝上
        },
        series: [{
          type: 'bar',
          barWidth: '30%', // 设置柱状图的宽度
          barGap: '-60%', // 调整柱状图的位置偏移量
          data: this.department.map((item) => {
            if (item.name !== "总计") {
              return item.backed_profit_rate; // 利润数据
            }
          }),
          itemStyle: {
            normal: {
              color: function (params) {
                return params.value >= 0 ? '#0a652f' : 'red'; // 利润正数蓝色，负数红色
              },
            }
          }
        },
        {
          type: 'bar',
          data: this.department.map((item) => {
            if (item.name !== "总计") {
              return item.backed_amount_rate;
            }
          }),
          itemStyle: {
            normal: {
              color: function (params) {
                return params.value >= 0 ? 'blue' : '#0a652f'; // 利润率正数绿色，负数橙色
              },
            }
          }
        }],
        tooltip: {
          formatter: function (params) {
            let item = self.department.find((element) => element.name === params.name);
            if (item) {
               return params.name + ': ' + (params.value) + '%' + ':' + (item.total ? item.total : '') + ' : ' + (item.backed_profit ? item.backed_profit : '');
            }
          }
        }
      });
    },
    getXAxisLabel(index) {
      // 获取X轴刻度的标签
      const labels = ["年份", "一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"];
      return labels[index - 1];
    },
    getList() {
      let data = {
        year:  this.year.label || this.year,
      };
      this.one = ''
      this.two = ''
      this.three = ''
      OperationApi(data).then(res => {
        this.project_box = res.data.project;
        this.department = res.data.expend.department;
        this.type = res.data.expend.type;
        this.type_ch = res.data.expend.type_ch;
        let arr = res.data.chart;
        this.echarts_one = arr.slice(1, 8)
        this.echarts_one = this.echarts_one.map(val => {
          return {
            name: val[0],
            type: 'line',
            data: val.slice(1, 13)
          }
        })
        if (this.currentTab == 1) {
          this.$nextTick(() => {
            echarts.dispose(this.$refs.pieChart_two)
            echarts.dispose(this.$refs.pieChart_two_1)
            echarts.dispose(this.$refs.pieChart_two_2)
            this.initChart_tow()
            this.initChart_tow_1()
            this.initChart_tow_2()
          })
          this.tableData_one = res.data;
          this.type.forEach((item) => {
             if (item.backed_profit || item.converted_profit || item.finish_profit) {
              return;
            }
            this.one = item.converted_amount;
            this.two = item.finish_amount;
            this.three = item.backed_amount;
          });
        } else if (this.currentTab == 2) {
          this.tableData_one = res.data;
          this.type_ch.forEach((item) => {
           if (item.backed_profit || item.converted_profit || item.finish_profit) {
              return;
            }
            this.one = item.converted_amount;
            this.two = item.finish_amount;
            this.three = item.backed_amount;
          });
          this.$nextTick(() => {
            echarts.dispose(this.$refs.pieChart_one)
            echarts.dispose(this.$refs.pieChart_one_1)
            echarts.dispose(this.$refs.pieChart_one_2)
            this.initChart_one()
            this.initChart_one_1()
            this.initChart_one_2()
          })
        } else if (this.currentTab == 3) {
          this.tableData_one = res.data;
          this.department.forEach((item) => {
             if (item.backed_profit || item.converted_profit || item.finish_profit) {
              return;
            }
            this.one = item.converted_amount;
            this.two = item.finish_amount;
            this.three = item.backed_amount;
          });
          this.$nextTick(() => {
            echarts.dispose(this.$refs.pieChart_three)
            echarts.dispose(this.$refs.pieChart_three_1)
            echarts.dispose(this.$refs.pieChart_three_2)
            this.initChart_three()
            this.initChart_three_1()
            this.initChart_three_2()
          })
        }
      })
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../../style/space.less");

.el-main {
  left: 175px;
  /* 与左侧项目管理列表的宽度保持一致 */
  padding: 0px;
  /* 添加一些内边距，使内容不紧贴在边缘 */
  top: 50px;
  position: relative;
}

.gray-background {
  background-color: #ccc;
  height: 100%;
  display: flex;
}

.conte_left {
  width: 100%;
  height: 480px;
  display: flex;

  .btn_box {
    margin-top: 10px;
    border: 1px solid #d1d1d1;
    border-radius: 5px;
    width: 100px;
    background-color: #ece8e8;
    font-size: 14px;
    text-align: center;
    height: 30px;
    line-height: 30px;
  }

  .btn {
    display: flex;
    justify-content: space-between;
    font-size: 14px;

    .fund {
      display: flex;
      flex-direction: column;

      width: 225px;
      height: 167px;
      text-align: left;
      background-color: #fff;
      border-radius: 5px;
      margin-top: 10px;

      span {
        margin-left: 20px;
        margin-top: 10px;
      }
    }

    .fund_box {
      display: flex;
      flex-direction: column;
    }
  }
}

.Echart {
  background-color: #fff;
  margin-top: 20px;
  border-radius: 5px;
}


.container {
  display: flex;
  padding: 10px 10px;

  .tab {
    cursor: pointer;
  }

  span {
    font-size: 14px;
    border-left: 1px solid #d1d1d1;
    padding: 5px 10px;
    border: 1px solid #d1d1d1;
  }

}


.tabs {
  .tab-content {
    height: 100%;
    overflow: auto;

    .el-table {
      border: 1px solid #d1d1d1;
      font-size: 12px;
    }

    div {
      border-radius: 5px;
    }
  }
}

.container .tab {
  color: #d1d1d1;
  /* 未选中状态的字体颜色为灰色 */
  margin-top: 5px;
}

.container .tab.active {
  color: black;
  /* 选中状态的字体颜色为黑色 */
}

.table_one {
  height: 255px;
  margin-top: 10px;
  border-radius: 5px;
  background-color: #fff;

  .table_box {
    font-size: 14px;

    tr {
      width: 100px;
      margin-top: 10px;
    }

    th {
      width: 100px;
      padding-top: 20px;
      text-align: left;
      text-indent: 1em;
      padding-bottom: 20px;
    }

    td {
      width: 100px;
      height: 34px;
      text-align: left;
      text-indent: 1em;
    }

  }
}


.el-select /deep/.el-input__inner {
  height: 30px !important;
}

.line-chart {
  width: 100%;
  height: 400px;
}

/deep/.project_one {
  background: #f9fdf5 !important;
}

/deep/.project_two {
  background: #eaffeb !important;
}

/deep/.project_three {
  background: #ebf9ff !important;
}

/deep/.el-table__footer tbody tr .project_one {
  background: #fff !important;
}

/deep/.el-table__footer tbody tr .project_two {
  background: #fff !important;
}

/deep/.el-table__footer tbody tr .project_three {
  background: #fff !important;
}


/deep/.el-table .el-table__cell {
  padding: 8px 0;
}
</style>



// WEBPACK FOOTER //
// src/src/Operations/index.vue